<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="board" :is-print="isPrint" />

    <!-- 인증서 정보 -->
    <write-grid-container title="인증서 정보" v-model="form" :options="gridContainerOptions" class="sub mt-7">
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint" class="printing">
          <div class="print-input">{{ form[value] }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <vs-select v-if="dataType === 'selector'" class="w-full" autocomplete v-model="form[value]" >
            <vs-select-item v-for="item in ['정상', '비정상', '비상']" :text="item" :value="item"/>
          </vs-select>
          <ml-input v-else class="w-full" v-model="form[value]" visible-counter :max="100" />
        </div>
      </template>
    </write-grid-container>


    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import DateSelector from "@/components/selector/DateSelector.vue";

export default {
  components: {
    DateSelector,
    WriteGridContainer,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  computed: {
  },
  data() {
    return {
      form: {
        stdInfo: {},
        팀명: "",
        공장명: "",
        공정명: "",
        상태: "",
        활동명: "",
        fileList: [],
      },
      gridContainerOptions: {
        dataTypes: ["string", "string", "string", "string"],
        labels: ["팀명", "공장명", "공정명", "활동명"],
        values: ["팀명", "공장명", "공정명", "활동명"],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }

  },
  methods: {
  },
};
</script>

<style scoped lang="scss"></style>
